import React from 'react';

class RuleContainer extends React.Component {

    constructor(props) {
        super(props);

        this.getListFilter = this.getListFilter.bind(this);
    }

    getListFilter(value, criteria) {
        const listFilter = { where: [] };

        if (!value) {
            return listFilter;
        }

        const contentType = manywho.utils.getObjectDataProperty(value.properties, 'ContentType').contentValue;
        
        if (manywho.utils.isEqual(criteria, 'IS_EMPTY', true)) {
            listFilter.where.push({
                columnName: 'ContentType',
                criteriaType: 'EQUAL',
                value: manywho.component.contentTypes.boolean,
            });
            return listFilter;
        }

        if (
            manywho.utils.isEqual(contentType, manywho.component.contentTypes.object, true) ||
            manywho.utils.isEqual(contentType, manywho.component.contentTypes.list, true)
        ) {
            listFilter.where.push({
                columnName: 'TypeElementId',
                criteriaType: 'EQUAL',
                value: manywho.utils.getObjectDataProperty(value.properties, 'TypeElementPropertyTypeElementId').contentValue 
                    || manywho.utils.getObjectDataProperty(value.properties, 'TypeElementId').contentValue,
            });
        }

        listFilter.where.push({
            columnName: 'ContentType',
            criteriaType: 'EQUAL',
            value: contentType,
        });

        return listFilter;
    }

    render() {
        return React.createElement(this.props.component, { getListFilter: this.getListFilter, ...this.props });
    }
}

export default RuleContainer;
